export default "__VITE_ASSET___OY7PI9G__"